import { render, staticRenderFns } from "./G_040_HatchuConfirm_Table.vue?vue&type=template&id=70ec6bac&scoped=true&"
import script from "./G_040_HatchuConfirm_Table.vue?vue&type=script&lang=ts&"
export * from "./G_040_HatchuConfirm_Table.vue?vue&type=script&lang=ts&"
import style0 from "./G_040_HatchuConfirm_Table.vue?vue&type=style&index=0&id=70ec6bac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ec6bac",
  null
  
)

export default component.exports